import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   listFleetExpiredDocumentApiCall,   
} from "../../Api/api";


// initial state
const initialState = {
   dataList: [],
   singleFleetMaster: null,

   tonnage: [],
   dimension: [],
   make: [],
   vehicleCategory: [],
   location: [],
   driverDropdownData: [],

   singleFleetTyres: [],
   singleFleetServiceRecords: [],
   singleFleetMonthlyBudget: [],

   isLoading: false,
   isError: false,
   isSuccess: false,
};




export const listFleetExpratioRecordAsync = createAsyncThunk(
   "fleetmaster/list-fleet-expired-records",
   async ({ err, done }, thunkAPI) => {
      try {
         const response = await listFleetExpiredDocumentApiCall();

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();

         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);



// fleet master slice
const fleetMasterExpirationSlice = createSlice({
   name: "fleetMasterExpiration",

   initialState: initialState,

   reducers: {
      clearFleetMasterState: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      //
      builder.addCase(listFleetExpratioRecordAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(listFleetExpratioRecordAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.dataList = action.payload;
      });
      builder.addCase(listFleetExpratioRecordAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

   },
});

export const { clearFleetMasterState } = fleetMasterExpirationSlice.actions;

const fleetMasterExpirationReducer = fleetMasterExpirationSlice.reducer;

export default fleetMasterExpirationReducer;
